import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const PrivateRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      const userStr = localStorage.getItem("user");
      
      console.log("PrivateRoute - Vérification pour:", location.pathname);
      
      setIsAuthenticated(!!(token && userStr));
      setIsChecking(false);
    };

    // Petit délai pour simuler le chargement (optionnel)
    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isChecking) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
        <span className="ms-3">Chargement...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/pages/signin2" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;